import Swiper, { Autoplay, EffectCreative, Navigation, Pagination } from "swiper";

document.addEventListener('DOMContentLoaded', () => {
  const testimonialSlider = document.querySelector('.testimonials__slider')
  const prevEl = document.querySelector('.testimonials__navigation .reviews-page__navigation-button--prev')
  const nextEl = document.querySelector('.testimonials__navigation .reviews-page__navigation-button--next')
  const slides = testimonialSlider?.querySelectorAll('.testimonials__slide')
  const preloader = document.querySelector('.preloader')
  if (testimonialSlider && prevEl && nextEl) {
    const swiper = new Swiper(testimonialSlider, {
      modules: [EffectCreative, Pagination, Autoplay, Navigation],
      effect: "creative",
      speed: 1000,
      parallax: true,
      spaceBetween: 2,
      loop: true,
      autoplay: {
        delay: 10000
      },
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      pagination: {
        el: '.pagination',
        bulletClass: 'testimonials__pagination pagination__item',
        bulletActiveClass: 'pagination__item--active',
        clickable: true,
      },
      navigation: {
        prevEl,
        nextEl
      }
    })

    swiper.autoplay.stop()

    let slideChange
    let throttle = false

    const startTimeout = () => {
      clearTimeout(slideChange)
      if (throttle) {
        slideChange = setTimeout(() => {
          throttle = false
          swiper.slideNext()
          swiper.autoplay.start()
        }, 30000)
      }
    }

    let animate = false
    const activePagination = document.querySelector('.pagination__item--active')
    if (activePagination) {
      activePagination.classList.remove('pagination__item--active')
    }
    const startAnimate = () => {
      if (animate) return
      animate = true
      swiper.autoplay.start()
      activePagination?.classList.add('pagination__item--active')
      startTimeout()
    }
    window.addEventListener('scroll', () => {
      if (window.scrollY > testimonialSlider.offsetTop + testimonialSlider.clientHeight) return
      if (window.scrollY >= testimonialSlider.offsetTop) {
        startAnimate()
      }
    })

    swiper.on('touchMove', () => throttle = true)

    swiper.on('slideChange', startTimeout)

    const paginations = document.querySelectorAll('.testimonials__pagination')

    paginations.forEach(pagination => {
      pagination.addEventListener('click', () => throttle = true)
    })
    const resize = () => {
      slides.forEach(slide => {
        slide.style.height = `${testimonialSlider.clientHeight}px`
      })
    }
    window.addEventListener('resize', resize)


    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('resize', resize)
          resize()
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.5 })
    observer.observe(testimonialSlider)
  }
})